module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"next":"Next"}}')
  delete Component.options._Ctor
}
